import { INews } from 'models/News/INews'
import { TranslationKeys } from 'types/TranslationKeys'

export interface LatestNewsProps {
  news: INews[] | null
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useLatestNews = (props: LatestNewsProps) => {
  return {
    ...props,
  }
}
